import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";

const SetupCashAvailableScreen = () => {
  const navigate = useNavigate();
  const [cashAmount, setCashAmount] = useState("");
  const [currency, setCurrency] = useState("USD");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!cashAmount || parseFloat(cashAmount) < 0) {
      alert("Please enter a valid cash amount");
      return;
    }

    console.log("Setting cash available:", { amount: cashAmount, currency });
    alert("Cash available updated successfully!");
    navigate("/");
  };

  const currencies = [
    { code: "USD", symbol: "$", name: "US Dollar" },
    { code: "EUR", symbol: "€", name: "Euro" },
    { code: "GBP", symbol: "£", name: "British Pound" },
    { code: "JPY", symbol: "¥", name: "Japanese Yen" },
    { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
    { code: "AUD", symbol: "A$", name: "Australian Dollar" },
    { code: "DKK", symbol: "kr", name: "Danish Krone" },
  ];

  const quickAmounts = [1000, 5000, 10000, 25000, 50000, 100000];

  return (
    <div className="screen">
      <div className="screen-header">
        <h1 className="screen-title">Setup Cash Available</h1>
        <p className="screen-subtitle">
          Set your available cash for investment tracking
        </p>
      </div>

      <div className="form-container" style={{ maxWidth: "600px" }}>
        <form onSubmit={handleSubmit}>
          {/* Currency Selection */}
          <div className="form-group">
            <label className="form-label">Currency</label>
            <select
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              className="form-input"
            >
              {currencies.map((curr) => (
                <option key={curr.code} value={curr.code}>
                  {curr.symbol} {curr.name} ({curr.code})
                </option>
              ))}
            </select>
          </div>

          {/* Cash Amount */}
          <div className="form-group">
            <label className="form-label">Available Cash Amount</label>
            <div style={{ position: "relative" }}>
              <span
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#94A3B8",
                  fontSize: "1.2rem",
                }}
              >
                {currencies.find((c) => c.code === currency)?.symbol}
              </span>
              <input
                type="number"
                value={cashAmount}
                onChange={(e) => setCashAmount(e.target.value)}
                className="form-input"
                style={{ paddingLeft: "40px" }}
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>
          </div>

          {/* Quick Amount Buttons */}
          <div className="card" style={{ marginBottom: "20px" }}>
            <div className="card-header">
              <h4 style={{ color: "#E5E7EB", margin: 0 }}>Quick Amounts</h4>
            </div>
            <div className="grid-3">
              {quickAmounts.map((amount) => (
                <button
                  key={amount}
                  type="button"
                  onClick={() => setCashAmount(amount.toString())}
                  className="btn btn-outline btn-small"
                >
                  {currencies.find((c) => c.code === currency)?.symbol}
                  {amount.toLocaleString()}
                </button>
              ))}
            </div>
          </div>

          {/* Current Cash Display */}
          {cashAmount && (
            <div className="card" style={{ marginBottom: "20px" }}>
              <div className="text-center">
                <div style={{ fontSize: "1.2rem", color: "#94A3B8" }}>
                  Available Cash
                </div>
                <div
                  style={{
                    fontSize: "2rem",
                    fontWeight: "bold",
                    color: "#E5E7EB",
                  }}
                >
                  {currencies.find((c) => c.code === currency)?.symbol}
                  {parseFloat(cashAmount).toLocaleString()}
                </div>
              </div>
            </div>
          )}

          {/* Information */}
          <div className="card" style={{ marginBottom: "20px" }}>
            <div style={{ color: "#94A3B8", lineHeight: "1.6" }}>
              <h4 style={{ color: "#E5E7EB", marginBottom: "8px" }}>
                About Available Cash
              </h4>
              <div>
                • This amount represents your liquid cash available for new
                investments
              </div>
              <div>
                • It helps track your total portfolio value including cash
              </div>
              <div>
                • You can update this amount anytime from your account settings
              </div>
              <div>• This is separate from your invested portfolio value</div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="grid-2" style={{ marginTop: "20px" }}>
            <button
              type="button"
              onClick={() => navigate("/")}
              className="btn btn-outline btn-large"
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-large">
              Save Cash Amount
            </button>
          </div>
        </form>
      </div>

      <Navigation />
    </div>
  );
};

export default SetupCashAvailableScreen;
